<template>
  <div>
    <div class="coupons-filter-inline hidden-sm">
      <span class="filter-label">{{ $t('Показать') }}:</span>
      <span :class="['filter-item', { 'active': selectedType === key }]" v-for="(type, key) in filteredTypes" :key="key" @click="selectType(key)">{{ $t(type) }}</span>
    </div>

    <div class="coupons-filter-select hidden-lg hidden-md">
      <div class="filter-select-wrapper" @click="openDropdown">
        <span>{{ $t(types[selectedType]) }}</span>
        <icon-base width="15" height="15"><icon-chevron-down/></icon-base>
      </div>
      <div class="filter-dropdown" v-if="dropdownOpened">
        <div :class="['filter-dropdown-item', { 'active': selectedType === key }]" v-for="(type, key) in filteredTypes" :key="key" @click="selectType(key)">
          {{ $t(type) }} <icon-base width="18" height="18" v-if="isAll(type)"><icon-chevron-up/></icon-base>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IconBase from '../IconBase.vue';
import IconChevronDown from '../icons/IconChevronDown.vue';
import IconChevronUp from '../icons/IconChevronUp.vue';

export default {
  name: 'shop-coupons-filter',

  components: {
    IconBase,
    IconChevronDown,
    IconChevronUp
  },

  props: {
    selectedType: String
  },

  data() {
    return {
      dropdownOpened: false,
      types: {
        'all': 'Всё',
        'promo': 'Промокоды',
        'action': 'Акции',
        /*'today': 'Только сегодня',*/
        'free_delivery': 'Бесплатная доставка'
      }
    };
  },

  computed: {
    ...mapState([
      'shopFiltersCount'
    ]),

    filteredTypes() {
      return Object.keys(this.types).reduce((acc, key) => {
        if (this.shopFiltersCount[key]) {
          acc[key] = this.types[key];
        }
        return acc;
      }, {});
    }
  },

  methods: {
    selectType(key) {
      this.$emit('update:selectedType', key);
    },

    openDropdown(e) {
      e.stopPropagation();
      this.dropdownOpened = true;
      const bodyClickHandler = () => {
        this.dropdownOpened = false;
        document.body.removeEventListener('click', bodyClickHandler);
      }
      document.body.addEventListener('click', bodyClickHandler);
    },

    isAll(key){
      return key == this.types.all;
    }
  }
};
</script>

<style scoped>
.coupons-filter-inline {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.filter-label {
  margin: 0 5px 0 0;
  color: #666872;
}

.filter-item {
  margin: 0 5px 0 0;
  border-radius: 25px;
  border: 1px solid #dbdce1;
  padding: 7px 17px;
  background-color: #fff;
  color: #666872;
  cursor: pointer;
}

.filter-item:hover {
  color: #3c91e6;
}

.filter-item:active {
  color: #29629c;
}

.filter-item.active {
  font-weight: bold;
  color: #666872;
}

.coupons-filter-select {
  position: relative;
}

.filter-select-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  width: 100%;
  font-size: 12px;
  font-weight: bold;
  background-color: #ffffff;
  cursor: pointer;
}

.filter-dropdown {
  z-index: 1;
  position: absolute; 
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 0px 5px 15px 0px rgba(6, 19, 50, 0.15);
}

.filter-dropdown-item {
  border-bottom: 1px solid #f0f1f4;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  font-size: 12px;
  cursor: pointer;
}

.filter-dropdown-item.active {
  align-items: center;
  font-weight: bold;
}
</style>
